import React from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

const StatCard = ({ icon: Icon, title, value, color = "primary", onClick }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Paper
      elevation={2}
      onClick={onClick}
      sx={{
        p: isMobile ? 1.5 : 2,
        height: isMobile ? 90 : 120,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        borderRadius: 2,
        cursor: onClick ? "pointer" : "default",
        transition: "transform 0.2s ease, box-shadow 0.2s ease",
        gap: 1.5,
        overflow: "hidden",
        "&:hover": onClick
          ? {
              transform: "translateY(-2px)",
              boxShadow: 4,
            }
          : {},
      }}
    >
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography
          variant={isMobile ? "h5" : "h4"}
          fontWeight="bold"
          color="text.primary"
          sx={{ lineHeight: 1.2 }}
        >
          {Number(value).toLocaleString("id-ID")}
        </Typography>
        <Typography
          variant={isMobile ? "body2" : "body1"}
          color="text.secondary"
          sx={{ mt: 0.5 }}
        >
          {title}
        </Typography>
      </Box>
      <Avatar
        sx={{
          width: isMobile ? 36 : 44,
          height: isMobile ? 36 : 44,
          flexShrink: 0,
          bgcolor: `${color}.main`,
          color: `${color}.contrastText`,
        }}
      >
        <Icon fontSize={isMobile ? "small" : "medium"} />
      </Avatar>
    </Paper>
  );
};

export default StatCard;
